import React, { useEffect, useState } from 'react'
import Navbar from './Navbar';
import "./style/crew.css"
import { Heading } from './destination';
import dt from '../data.json'

//slider 

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import "./styles.css";

// import required modules
import { Pagination } from "swiper";

const Crew = () => {
  const [bgImg, setBgimg] = useState("url('./assets/crew/background-crew-desktop.jpg')")
  useEffect(() => {
    if (window.innerWidth <= 768 && window.innerWidth > 450) {
      setBgimg(`url("./assets/crew/background-crew-tablet.jpg")`)
    } else if (window.innerWidth <= 660) {
      setBgimg(`url("./assets/crew/background-crew-mobile.jpg")`)
    }
  }, [bgImg])
  return (
    <div className="crew" style={{ background: `${bgImg}` }}>
      <Navbar />
      <div className="crew-content">
        <Heading num={"02"} title={"Meet Your Crew"} />

<div className="wrapper">
<Swiper
        spaceBetween={30}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        className="mySwiper"
      >
{
    dt.crew.map((arr,index)=>{
      return(
        <SwiperSlide>
        <div className="crew-info" key={index}>
        <span className="crew-role">
      {arr.role}
    </span>
    <span className="crew-name">
{
  arr.name
}
    </span>
   
    <span className="crew-bio">{
      arr.bio
    }</span>
        </div>
        <div id="crew-img-container">
        <img id="crew-img" src={arr.images.png} alt="" key={index}/>
        </div>
       
      </SwiperSlide>
      )
    
              })
}
    
      
     

      </Swiper>
</div>
      </div>
    </div>
  )
}

export default Crew